<template>
  <div class="t-side-menu">
    <el-menu
      :default-active="currentActive"
      class="el-menu-vertical-demo"
      background-color="#232933"
      text-color="#fff"
      active-text-color="#ffd04b"
      :collapse="isMini"
      >
      <template v-for="(menu, index) in filteredMenus">
        <el-menu-item-group v-if="menu.isGroup" :key="index">
          <template slot="title">{{menu.label}}</template>
          <el-menu-item
            v-for="(submenu, index2) in menu.children"
            :key="index + '-' + index2"
            :index="menu.fullPath || index + '-' + index2"
            @click="handleClick(submenu)"
            >
            <i :class="submenu.icon || 'el-icon-document'"></i><span slot="title">{{submenu.label}}</span>
          </el-menu-item>
        </el-menu-item-group>
        <el-submenu :key="index" v-else-if="menu.children" :index="index + ''">
          <template slot="title"><i :class="menu.icon || 'el-icon-document'"></i><span>{{menu.label}}</span></template>
          <template v-for="(submenu, index2) in menu.children">
            <el-menu-item-group v-if="submenu.isGroup" :key="index + '' + index2">
              <template slot="title">{{submenu.label}}</template>
              <el-menu-item
                v-for="(group, index3) in submenu.children"
                :key="index + '-' + index3"
                :index="group.fullPath || index + '-' + index3"
                @click="handleClick(group)"
                >
                <i :class="group.icon"></i><span slot="title">{{group.label}}</span>
              </el-menu-item>
            </el-menu-item-group>
            <el-menu-item
              v-else
              :key="index + '-' + index2"
              :index="submenu.fullPath || index + '-' + index2"
              @click="handleClick(submenu)"
              >
              <i :class="submenu.icon"></i><span slot="title">{{submenu.label}}</span>
            </el-menu-item>
          </template>
        </el-submenu>
        <el-menu-item v-else :key="index" :index="menu.fullPath || index + ''" @click="handleClick(menu)">
          <i :class="menu.icon || 'el-icon-document'"></i>
          <span slot="title">{{menu.label}}</span>
        </el-menu-item>
      </template>

    </el-menu>
  </div>
</template>
<script>
import menuList from '../routes'
import { mapState } from 'vuex'

export default {
  props: {
    isMini: Boolean
  },
  data () {
    return {
      menuList,
      currentActive: ''
    }
  },
  computed: {
    ...mapState('user', ['apiList']),
    filteredMenus() {
      if (!this.asideMenu) return [];
      // 菜单有apiName的情况，需要限制
      const hasMenuPermission = (menu) =>
        !(menu.meta && menu.meta.apiName) || this.apiList.includes(menu.meta.apiName);
      // 子菜单有apiName的情况，需要限制
      const filterChildren = (children) =>
        children.map(child => filterMenu(child)).filter(child => child !== null);
      const filterMenu = (menu) => {
        const hasPermission = hasMenuPermission(menu);
        // 无子菜单的情况
        if (!menu.children || menu.children.length === 0) {
          return hasPermission ? menu : null;
        }
        // 有子菜单的情况
        const filteredChildren = filterChildren(menu.children)
        if (filteredChildren.length === 0 && !hasPermission) {
          return null;
        }
        return {
          ...menu,
          children: filteredChildren,
        };
      }
      return this.makeMenu(this.asideMenu.children, this.asideMenu.path)
        .map(filterMenu)
        .filter(menu => menu !== null);
    },
    asideMenu () {
      return this.menuList.find(e => e.isAside) || null
    },
    menus () {
      if (!this.asideMenu) return []
      const list = this.asideMenu.children

      return this.makeMenu(list, this.asideMenu.path)
    }
  },
  updated () {
    this.currentActive = this.$route.path
  },
  created () {
    this.currentActive = this.$route.path
  },
  methods: {
    toPath () {
      const paths = []
      for (let i = (arguments.length - 1); i >= 0; i--) {
        const path = arguments[i]
        if (!path) continue
        paths.unshift(path)
        if (/^\//.test(path)) {
          break
        }
      }
      return paths.join('/')
    },
    makeMenu (list, path = null) {
      const newList = []
      for (let i in list) {
        const menu = list[i]
        if (menu.show || typeof menu.show === 'undefined') {
          if (Array.isArray(menu.children)) {
            newList.push({
              ...menu,
              children: this.makeMenu(menu.children, this.toPath(path, menu.path)),
              fullPath: this.toPath(path, menu.path)
            })
          } else {
            newList.push({
              ...menu,
              fullPath: this.toPath(path, menu.path)
            })
          }
        }
      }
      return newList
    },
    handleClick (menu) {
      if (menu.link) {
        this.currentActive = ''
        window.open(menu.link)
      } else {
        this.$router.push({ path: menu.fullPath })
      }
    }
  }
}
</script>
